// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const SearchPlus: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15">
            <path fill="currentColor" d="M10.28125,9.04257846 C10.9703128,8.10195363 11.375,6.94257838 11.375,5.68750042 C11.375,2.54570329 8.82929671,0 5.6875,0 C2.54570329,0 0,2.54570329 0,5.6875 C0,8.82929671 2.54570329,11.375 5.68750042,11.375 C6.94257838,11.375 8.10195321,10.9675783 9.04257888,10.28125 L12.0695315,13.3054689 L12.6875004,13.9261715 L13.926172,12.6875 L13.308203,12.0695311 L10.2812504,9.04257846 L10.28125,9.04257846 Z M6.34375042,2.84375 L6.34375042,3.5 L6.34375042,5.03125 L7.87500042,5.03125 L8.53125042,5.03125 L8.53125042,6.34375 L7.87500042,6.34375 L6.34375042,6.34375 L6.34375042,7.875 L6.34375042,8.53125 L5.03125042,8.53125 L5.03125042,7.875 L5.03125042,6.34375 L3.50000042,6.34375 L2.84375042,6.34375 L2.84375042,5.03125 L3.50000042,5.03125 L5.03125042,5.03125 L5.03125042,3.5 L5.03125042,2.84375 L6.34375042,2.84375 Z" transform="translate(0 .75)"/>
        </svg>
    );
};

export default React.memo(SearchPlus);
